import React, { useEffect } from "react";

/**
 * Global script manager
 * Third-party Tawk.to widget removed per brand & UX guidelines
 * to eliminate intrusive popups and distracting animated widgets.
 */
const UseScript = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Remove any residual Tawk.to DOM nodes or active iframes if cached
    try {
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === "function") {
        window.Tawk_API.hideWidget();
      }
      const tawkElements = document.querySelectorAll("[id*='tawk'], [class*='tawk'], iframe[src*='tawk.to']");
      tawkElements.forEach((el) => {
        if (el && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    } catch (e) {
      // Fail silently
    }
  }, []);

  return null;
};

export default UseScript;
